import IcoW01 from 'dc/IcoW01';
import styled from 'styled-components';

type WrapperProps = {
  small?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  padding: ${props => (props.small ? '16px' : '24px')};
  border-radius: 8px;
  background-color: #ccecf4;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const CloseButton = styled(IcoW01)`
  position: absolute;
  top: 0px;
  right: 0px;
`;

type TitleProps = {
  small?: boolean;
};

export const Title = styled.span<TitleProps>`
  font-size: ${props => (props.small ? '12px' : '16px')};
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.12px;
  color: #004050;
  margin-bottom: 8px;
`;

type TextProps = {
  small?: boolean;
};

export const Text = styled.span<TextProps>`
  font-size: ${props => (props.small ? '12px' : '16px')};
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #004050;
  a {
    color: inherit;
    text-decoration: underline;
  }
`;
